import React from "react";
import mystyles from './loading.module.css';

export default function Loading() {
    return (
        <div className={mystyles.loadingScreen}>
            <div className={mystyles.loadingSpinner}/>
            <div className={'mt-3'}>Loading</div>
        </div>
    );
}